import { HTTP_GET, WebApiRequest } from "tools/webservice";
import appraisalSurvey from "apis/appraisal-survey";

export const getWaiverResults = (controlNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: appraisalSurvey.getWaiverResults(controlNumber),
  successCallback,
  errorCallback,
  mountedRef
});

